export interface MessageConfig {
  heading?: string;
  detailsHtml?: string;
  primaryText?: string;
  primaryCallback?: () => void;
  secondaryText?: string;
  secondaryCallback?: () => void;
}

export class MessageService {
  private modalLayer: HTMLElement;
  private message: HTMLElement;

  showWarning(config: MessageConfig): void {
    if (!this.modalLayer) {
      this.modalLayer = this.createModalLayer();
    }

    if (!this.message) {
      this.message = this.createMessage();
      this.modalLayer.appendChild(this.message);
    }

    this.updateMessage(config);
    document.body.appendChild(this.modalLayer);
    this.modalLayer.style.display = 'flex';
  }

  cancelLastMessage(): void {
    /* istanbul ignore next else */
    if (this.modalLayer) {
      this.modalLayer.style.display = 'none';
    }
  }

  private createModalLayer(): HTMLElement {
    const layer = document.createElement('div');
    layer.classList.add('modal-layer');
    layer.id = 'message-modal-layer';
    layer.style.display = 'flex';

    return layer;
  }

  private createMessage(): HTMLElement {
    const message = document.createElement('div');
    message.classList.add('message');
    message.setAttribute('role', 'dialog');
    message.setAttribute('aria-labelledby', 'dialog-title');
    message.setAttribute('aria-describedby', 'messageInfo');
    return message;
  }

  private updateMessage(config: MessageConfig) {
    const oldHeading = this.message.querySelector('[data-nav-msg=head]');
    if (oldHeading) {
      this.message.removeChild(oldHeading);
    }

    const oldDetails = this.message.querySelector('[data-nav-msg=details]');
    if (oldDetails) {
      this.message.removeChild(oldDetails);
    }

    const oldFooter = this.message.querySelector('[data-nav-msg=footer]');
    if (oldFooter) {
      this.message.removeChild(oldFooter);
    }

    if (config.heading) {
      const head = document.createElement('header');
      head.dataset.navMsg='head';
      head.classList.add('message__head');
      head.innerHTML = `<svg class="message__svg" xmlns="http://www.w3.org/2000/svg"><use xlink:href="#nav_warning"></use></svg><div class="message__heading">${config.heading}</div>`;
      head.setAttribute('id', 'dialog-title');
      this.message.appendChild(head);
    }

    if (config.detailsHtml) {
      const details = document.createElement('main');
      details.dataset.navMsg='details';
      details.classList.add('message__details');
      details.innerHTML = config.detailsHtml;
      details.setAttribute('id', 'messageInfo');
      this.message.appendChild(details);
    }

    if (config.primaryText || config.secondaryText) {
      const footer = document.createElement('footer');
      footer.dataset.navMsg = 'footer';
      footer.classList.add('message__footer');

      if (config.secondaryText) {
        const actionButton = document.createElement('button');
        actionButton.classList.add('message__button--right', 'button', 'button--secondary');
        actionButton.innerText = config.secondaryText;
        if (config.secondaryCallback) {
          actionButton.addEventListener('click', config.secondaryCallback);
        }
        footer.appendChild(actionButton);
      }

      if (config.primaryText) {
        const actionButton = document.createElement('button');
        actionButton.classList.add('message__button--right', 'button', 'button--primary');
        actionButton.innerText = config.primaryText;
        if (config.primaryCallback) {
          actionButton.addEventListener('click', config.primaryCallback);
        }
        footer.appendChild(actionButton);
      }

      this.message.appendChild(footer);
    }
  }
}

export const messageService = new MessageService();
